import axiosInstance from './AxiosInstance'; // Reuse the centralized Axios instance

const FacilityService = {
  fetchFacility: async (page, pageSize, sortBy, order,searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order,
      searchTerm: searchTerm?.trim() || "", 
    };
    
    try {
      const response = await axiosInstance.get('/facility', {
        params:queryObj, 
      });
      console.log("response",response.data);
      
      return response.data;
    } catch (error) {
      console.error('Error fetching Facilitys:', error);
      throw error;
    }
  },


  createFacility: async (data) => {
    try {
      const response = await axiosInstance.post('/facility', data);
      return response.data;
    } catch (error) {
      console.error('Error creating Facility:', error);
      throw error;
    }
  },

  updateFacility: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/facility/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating Facility with ID ${id}:`, error);
      throw error;
    }
  },

  deleteFacility: async (id) => {
    try {
      const response = await axiosInstance.delete(`/facility/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting Facility with ID ${id}:`, error);
      throw error;
    }
  },
};

export default FacilityService;
